import { useTranslation } from 'providers/GILT.provider';

import { AddClientButton } from './AddClientButton.component';

export const CheckoutTitle = ({ className, onAddHandler, hasClients }) => {
  const { t } = useTranslation();

  return (
    <div className={`checkout-add-booking ${className}`}>
      <div className="toolbar-row empty-client">
        <div className="name">{t('checkout.checkoutTitle.title')}</div>
        <div className="next-appointment" />
      </div>
      {!hasClients && (
        <div className="add-client-button">
          <AddClientButton onAddClient={onAddHandler} buttonText={t('checkout.checkoutTitle.addClient')} />
        </div>
      )}
    </div>
  );
};
